import React from 'react';

import { Pagination as MuiPagination } from '@mui/material';

import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';

import { ListingsSearchContext } from '@kamernet/views/ListingsSearch/ListingsSearchContext';

import styles from './Pagination.module.css';

const PaginationInternal = () => {
  const isMobile = !useMediaIsDesktop();

  const { allFilters, applyNewAllFilters, totalListingsCount } =
    ListingsSearchContext.useContext();

  const totalPageCount = Math.ceil(
    totalListingsCount / allFilters.listingsPerPage,
  );

  const handlePaginationChange = React.useCallback(
    (_event: React.ChangeEvent<unknown>, pageNo: number) => {
      window.scrollTo(0, 0);
      applyNewAllFilters({
        pageNo,
      });
    },
    [applyNewAllFilters],
  );

  if (totalPageCount <= 1) {
    return null;
  }

  return (
    <MuiPagination
      className={styles.pagination}
      size={isMobile ? 'small' : 'medium'}
      count={totalPageCount}
      page={allFilters.pageNo || 1}
      shape="rounded"
      onChange={handlePaginationChange}
    />
  );
};

export const Pagination = React.memo(PaginationInternal);
